import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { UserPreferenceService } from '../../services/user-preferences/user-preference.service';
import { CVANotificationService } from '../../services/cva-notification/cva-notification.service';
import { NotificationClassEnum } from '../../models/notification-class.enum';
import { CVA_CONSTANTS, StorageKeys, VIEW_MODE } from '../../util/constants';
import { RecordType } from '../../models/common.interface';
import { PreferenceResponse, PreferenceMeta, UserPreferencePayload } from '../../models/soap-config.interface';
import { PractitionerService } from '../../services/practitioner/practitioner.service';
import { SoapServiceService } from '../../services/soap-service/soap-service.service';
import { ISelectedAppointment } from '../../models/storage.interface';
import { StorageService } from '../../services/storage-service/storage.service';
import { ROUTE_CONSTANTS } from '../../util/route.constants';
import { Router } from '@angular/router';
import { CustomTemplateService } from '../../services/custom-template/custom-template.service';
import { ActionClick, GridColumn } from '../../models/data-table.interface';
import { CreatedBy } from '../../models/template.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDailogComponent } from '../confirm-dailog/confirm-dailog.component';
import { FavTemplateRequest, ITab, TemplateListing } from '../../models/manage-template.interface';
import { ConfirmationDialogService } from '../../shared/confirmation-dialog/services/confirmation-dialog.service';
import { finalize, lastValueFrom } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from '../../../environments/environment';
import { ViewTemplateComponent } from '../manage-template/view-template/view-template.component';
import { PractitionerResponse } from '../../models/practitioner.interface';
type PreferenceKey = 'patientConsent' | 'consultationFont' | 'approvePopup' | 'patientHistory' | 'accEligibilityRecipient' | 'showLiveTranscription';


@Component({
  standalone: false,
  selector: 'cva-soap-configuration',
  templateUrl: './soap-configuration.component.html',
  styleUrls: ['./soap-configuration.component.scss'],

})

export class SoapConfigurationComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  isLoading = true;
  SoapConfigureViewMobile = false;
  CREATED_BY = CreatedBy;
  pageSize: number = 10;
  pageSizeOptions: number[] = [5, 10, 15, 20, 25, 30];
  filterName: string = '';
  paginationLength = 0
  practitionerId!: string;
  referenceId: string | undefined;
  defaultTemplate: string = "";
  soaptemplateSettingUid: string | undefined;
  patientConsentUid: string | undefined;
  soapTemplateOptions: RecordType[] = [];
  patientConsent: boolean = true;
  consultationFont: string;
  approvePopup: boolean;
  showLiveTranscription: boolean = false;
  patientHistory: number = 0;
  userPreference: object;
  accEligibilityRecipient: string;
  accEligibilityAllRecipients: PractitionerResponse[] = [];
  isLoadingAccRecipients = false;
  preferenceKeyMap: Record<PreferenceKey, PreferenceMeta> = {
    patientConsent: { key: 'patient_consent', message: CVA_CONSTANTS.MESSAGE.PATIENT_CONSENT_POPUP },
    consultationFont: { key: 'consultation_font', message: CVA_CONSTANTS.MESSAGE.CONSULTATION_NOTE_FONT },
    approvePopup: { key: 'approve_popup', message: CVA_CONSTANTS.MESSAGE.APPROVE_POPUP_NOTE },
    patientHistory: { key: 'patient_history', message: CVA_CONSTANTS.MESSAGE.PATIENT_HISTORY_NOTE },
    accEligibilityRecipient: { key: 'acc_eligibility_recipient', message: CVA_CONSTANTS.MESSAGE.ACC_ELIGIBILITY_RECIPIENT },
    showLiveTranscription: { key: 'show_live_transcription', message: CVA_CONSTANTS.MESSAGE.SHOW_LIVE_TRANSCRIPTION }
  };

  isLIC = localStorage.getItem('isLIC') === 'true';
  @ViewChild(MatSort) sort!: MatSort;

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  tableHeaders: GridColumn<any>[] = [
    { field: "default", label: "", width: "1%", tdClass: "normal-text" },
    { field: "name", label: "Name", width: "15%", tdClass: "template-name", sortable: true },
    { field: "category", label: "Category", tdClass: "normal-text", sortable: true },
    { field: "privacy", label: "Visibility", tdClass: "normal-text", sortable: true },
    { field: "createdBy", label: "Created By", tdClass: " normal-text", sortable: true },
    { field: "createdAt", label: "Last Updated At", tdClass: "normal-text", isDate: true, sortable: true },
    { field: "actions", label: "Actions", width: "15%", isAction: true }
  ];
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  displayedColumns: any = [];
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  dataSource = new MatTableDataSource<any>();
  deleteConfirmationMessage: string = CVA_CONSTANTS.MESSAGE.DELETE_CONFIRMATION_MESSAGE;
  cvaUI_url = environment.cvaUI_url;

  constructor(
    private readonly router: Router,
    private readonly userPreferenceService: UserPreferenceService,
    private readonly cvaNotificationService: CVANotificationService,
    public dialog: MatDialog,
    private readonly providerService: PractitionerService,
    private readonly soapServiceService: SoapServiceService,
    private readonly storageService: StorageService,
    private readonly customTemplateService: CustomTemplateService,
    private readonly confirmationDialogService: ConfirmationDialogService
  ) {
    this.displayedColumns = this.tableHeaders.map(header => header.field);
    const providerId = localStorage.getItem('providerId') as string;
    this.practitionerId = providerId || '';
  }

  ngOnInit(): void {
    this.getPractitionerByHpiId();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  editRow(row: any) {
    this.router.navigate([`${ROUTE_CONSTANTS.MANAGE_TEMPLATES}/${ROUTE_CONSTANTS.EDIT}/${row.identifier}`]);
    // Implement edit logic
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  deleteRow(row: any) {
    const message = CVA_CONSTANTS.MESSAGE.CONFIRM_TO_DELETE_TEMPLATE;
    const confirmed$ = this.confirmationDialogService.openConfirmDialog(message);
    lastValueFrom(confirmed$).then((result: boolean) => {
      if (result) {
        this.deleteSavedTemplate(row.identifier);
      }
    });
  }

  deleteSavedTemplate(id: string) {
    this.customTemplateService.deleteById(id)
      .subscribe({
        next: (data: { response: TemplateListing[]; }) => {
          this.dataSource = new MatTableDataSource(data.response);
          this.deleteLocalData(id)
          this.getTemplateSetting();
          this.cvaNotificationService.showNotification(
            CVA_CONSTANTS.MESSAGE.TEMPLATE_DELETED,
            NotificationClassEnum.SUCCESS
          );
        },
        error: (e) => {
          const errorMessage = e?.error?.error?.errorMessage || CVA_CONSTANTS.MESSAGE.UNABLE_TO_FETCH_RECORDS;
          console.log("Template removing process failed", errorMessage);
          this.cvaNotificationService.showNotification(
            errorMessage,
            NotificationClassEnum.ERROR
          );
        },
      });
  }

  private deleteLocalData(identifier: string) {
    try {
      const tempConsultationForm = localStorage.getItem("consultationForm");
      const tempTabs = localStorage.getItem("tabs");
      if (tempConsultationForm && tempTabs) {
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        const localStorageConsultationForm: any = JSON.parse(tempConsultationForm);
        const localStorageTabs: ITab[] = JSON.parse(tempTabs);

        if (localStorageTabs) {
          const newLocalStorageTabs = localStorageTabs.filter((row) => { return row.identifier !== identifier })
          localStorage.setItem("tabs", JSON.stringify(newLocalStorageTabs));
        }

        if (localStorageConsultationForm) {
          for (const key in localStorageConsultationForm) {
            if (key.startsWith(identifier)) {
              delete localStorageConsultationForm[key];
            }
          }
          localStorage.setItem("consultationForm", JSON.stringify(localStorageConsultationForm));
        }
      }
    } catch (error) {
      console.error(error)
      this.cvaNotificationService.showNotification(
        CVA_CONSTANTS.MESSAGE.DELETE_TAB_ERROR,
        NotificationClassEnum.ERROR
      );
    }
  }

  onTemplateButtonClick() {
    // Navigate to the "Manage Template" page
    this.router.navigate([`${ROUTE_CONSTANTS.MANAGE_TEMPLATES}/${ROUTE_CONSTANTS.CREATE}`]);
  }
  getTemplates(showLoader = false) {
    if (showLoader) {
      this.isLoading = true;
    }
    this.customTemplateService.getData().subscribe({
      // eslint-disable-next-line  @typescript-eslint/no-explicit-any
      next: (res: any) => {
        if (res.response) {
          this.soapTemplateOptions = res.response;
          const result = this.soapServiceService.getTemplate(this.defaultTemplate, res.response);
          if (result) {
            this.defaultTemplate = result.templateType;
          }
          this.dataSource = new MatTableDataSource(this.soapTemplateOptions);
          setTimeout(() => {
            this.dataSource.sortingDataAccessor = (item, property) => {
              const value = item[property];
              return typeof value === 'string' ? value.toLowerCase() : value;
            };
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            // eslint-disable-next-line  @typescript-eslint/no-explicit-any
            this.dataSource.filterPredicate = (data: any, filter: string): boolean => {
              const normalizedFilter = filter.trim().toLowerCase();
              return (
                data.name.toLowerCase().includes(normalizedFilter) ||
                data.category.toLowerCase().includes(normalizedFilter)
              );
            };
            if (this.filterName) {
              this.dataSource.filter = this.filterName.trim().toLowerCase();
            }
          });
          this.loadDataAsperPage(this.soapTemplateOptions);
        }
        if (showLoader) {
          this.isLoading = false;
        }
      },
      error: (e) => {
        const errorMessage = e?.error?.error?.errorMessage || CVA_CONSTANTS.MESSAGE.UNABLE_TO_FETCH_RECORDS;
        this.cvaNotificationService.showNotification(
          errorMessage,
          NotificationClassEnum.ERROR
        );
        if (showLoader) {
          this.isLoading = false;
        }
      }
    });
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  onActionClick(record: ActionClick<any>): void {
    switch (record.action) {
      case "edit":
        this.editRow(record.rowData)
        break;
      case "delete":
        this.deleteRow(record.rowData)
        break;
      case "fav":
        this.onToggleFavorite(record.rowData)
        break;
      case "set-default":
        this.onTemplateTypeChange(record.rowData)
        break;
      default:
        break;
    }
  }

  getPractitionerByHpiId() {
    this.providerService.getPractitionerByHpiId(this.practitionerId).subscribe({
      next: () => {
        this.referenceId = this.providerService.loggedInPractitioner?.referenceId;
        this.getTemplateSetting();
        this.fetchAccEligibilityRecipients();
      },
      error: () => {
        this.isLoading = false;
      }
    })
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  onTemplateTypeChange(row: any) {
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    const obj: any = {
      preference_type: CVA_CONSTANTS.CONSTS.template_type,
      preference: { templateType: row.identifier }
    }
    if (this.soaptemplateSettingUid) {
      this.userPreferenceService.updateSoapSetting(this.soaptemplateSettingUid, obj).subscribe(() => {
        this.updateLocalSelectedAppointment(row.identifier);
        this.getTemplates();
        this.cvaNotificationService.showNotification(CVA_CONSTANTS.MESSAGE.SOAP_SETTINGS_SAVED_SUCCESSFULLY, NotificationClassEnum.SUCCESS, 3000);
      });
    } else {
      obj.referenceId = this.referenceId ? this.referenceId : '';
      this.userPreferenceService.saveSoapSettings(obj).subscribe((res: { response: PreferenceResponse }) => {
        this.soaptemplateSettingUid = res.response.uid;
        this.updateLocalSelectedAppointment(row.identifier);
        this.getTemplates();
        this.cvaNotificationService.showNotification(CVA_CONSTANTS.MESSAGE.SOAP_SETTINGS_SAVED_SUCCESSFULLY, NotificationClassEnum.SUCCESS, 3000);
      });
    }
  }
  updateLocalSelectedAppointment(templateType: string) {
    this.defaultTemplate = templateType;
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    const data: any = this.soapServiceService.getAppointmentAndDraftedNotes();
    if (data) {
      data.notes = "";
      this.storageService.setItem<ISelectedAppointment>(StorageKeys.SELECTED_APPOINTMENT, data);
    }
  }

  getTemplateSetting() {
    this.isLoading = true;
    if (this.referenceId) {
      this.userPreferenceService.getSoapSettings(this.referenceId, CVA_CONSTANTS.CONSTS.template_type)
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        .subscribe((res: any) => {
          this.soaptemplateSettingUid = res.uid;
          if (res.preference.templateType) {
            this.defaultTemplate = res.preference.templateType
          }
          this.getTemplates(true);
        }, () => {
          this.getTemplates(true);
        })
      this.userPreferenceService.getSoapSettings(this.referenceId, CVA_CONSTANTS.CONSTS.user_preference)
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        .subscribe((res: any) => {
          const patientConsent = Object.hasOwn(res?.preference ?? {}, 'patient_consent')
            ? res.preference.patient_consent
            : true;

          this.patientConsentUid = res.uid;
          this.patientConsent = patientConsent;
          this.userPreference = { ...res?.preference, patient_consent: patientConsent };
          this.consultationFont = res?.preference?.consultation_font;
          this.approvePopup = res?.preference?.approve_popup;
          this.patientHistory = res?.preference?.patient_history || 0;
          this.accEligibilityRecipient = res?.preference?.acc_eligibility_recipient || ''
          this.showLiveTranscription = res?.preference?.show_live_transcription || false;
        })
    } else {
      this.getTemplates(true);
    }
  }

  backToConsulation() {
    const appointment = this.soapServiceService.getCurrentAppointment();
    this.router.navigate([ROUTE_CONSTANTS.CONSULTATION],
      { state: { appointment, viewMode: VIEW_MODE.TAB, practitioner: this.providerService.loggedInPractitioner } });
  }

  onToggleFavorite(record: TemplateListing) {
    const message = record.starred
      ? CVA_CONSTANTS.MESSAGE.CONFIRM_TO_UN_MARK_TEMPLATE_FAV
      : CVA_CONSTANTS.MESSAGE.CONFIRM_TO_MARK_TEMPLATE_FAV;

    const dialogRef = this.dialog.open(ConfirmDailogComponent, {
      width: '300px',
      data: { title: message, buttonName: 'Confirm' },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.toggleTemplateFavStatus(record)
      }
    });
  }

  toggleTemplateFavStatus(record: TemplateListing) {
    const payload: FavTemplateRequest = {
      templateIdentifier: record.identifier,
      isCustomTemplate: record.isCustomTemplate,
      isFavorite: !record.starred
    }

    this.customTemplateService.markOrUnMarkFavoriteTemplate(payload)
      .subscribe({
        next: (data: { response: boolean }) => {
          if (data.response) {
            const template = this.soapTemplateOptions.find((data) => data['identifier'] === record.identifier);
            if (template) {
              template['starred'] = payload.isFavorite;
              this.getTemplates();
            }
          }
        },
        error: (e) => {
          const errorMessage = e?.error?.error?.errorMessage || CVA_CONSTANTS.MESSAGE.UNABLE_TO_PROCESS;
          console.log("Toggle template fav status process failed", errorMessage);
          this.cvaNotificationService.showNotification(
            errorMessage,
            NotificationClassEnum.ERROR
          );
        },
      });
  }


  loadDataAsperPage(array: RecordType[]) {
    array.sort((a: RecordType, b) => {
      if (this.defaultTemplate == a["identifier"]) {
        return -1;
      } else if (this.defaultTemplate == b["identifier"]) {
        return 1;
      }

      if (a["starred"] && !b["starred"]) {
        return -1;
      } else if (!a["starred"] && b["starred"]) {
        return 1;
      }

      return 0;
    })
    this.dataSource = new MatTableDataSource(array);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  clearFilter() {
    this.filterName = '';
    this.dataSource.filter = '';
  }

  templateViewer(record: TemplateListing): void {
    this.dialog.open(ViewTemplateComponent, {
      autoFocus: false,
      data: record,
    }).afterClosed()
      .subscribe(() => { });
  }

  updatePatientConsent() {
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    const obj: any = {
      preference_type: CVA_CONSTANTS.CONSTS.patient_consent,
      preference: { patient_consent: this.patientConsent }
    }
    if (this.patientConsent === false) {
      localStorage.setItem("disablePatientConsent", "true")
    } else {
      localStorage.removeItem("disablePatientConsent")
    }
    if (this.patientConsentUid) {
      this.userPreferenceService.updateSoapSetting(this.patientConsentUid, obj)
        .subscribe(() => {
          this.cvaNotificationService.showNotification(
            CVA_CONSTANTS.MESSAGE.PATIENT_CONSENT_POPUP,
            NotificationClassEnum.SUCCESS
          );
        });
    } else {
      obj.referenceId = this.referenceId ? this.referenceId : '';
      this.userPreferenceService.saveSoapSettings(obj).subscribe((res: { response: PreferenceResponse }) => {
        this.patientConsentUid = res.response.uid;
        this.cvaNotificationService.showNotification(
          CVA_CONSTANTS.MESSAGE.PATIENT_CONSENT_POPUP,
          NotificationClassEnum.SUCCESS
        );
      });
    }
  }

  updatePreference(field: PreferenceKey) {
    const obj: {
      preference_type: string;
      preference: UserPreferencePayload;
      referenceId: string;
    } = {
      preference_type: CVA_CONSTANTS.CONSTS.user_preference,
      preference: { ...this.userPreference, [this.preferenceKeyMap[field].key]: this[field] },
      referenceId: this.referenceId ? this.referenceId : ''
    };
    if (field === 'patientConsent') {
      if (this.patientConsent === false) {
        localStorage.setItem("disablePatientConsent", "true")
      } else {
        localStorage.removeItem("disablePatientConsent")
      }
    }
    if (this.patientConsentUid) {
      this.userPreferenceService.updateSoapSetting(this.patientConsentUid, obj)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .subscribe((res: any) => {
          this.userPreference = res.response.preference ? res.response.preference : this.userPreference;
          this.cvaNotificationService.showNotification(
            this.preferenceKeyMap[field].message,
            NotificationClassEnum.SUCCESS
          );
        });
    } else {
      obj.referenceId = this.referenceId ? this.referenceId : '';
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.userPreferenceService.saveSoapSettings(obj).subscribe((res: any) => {
        this.patientConsentUid = res.response.uid;
        this.userPreference = res.response.preference ? res.response.preference : this.userPreference;
        this.cvaNotificationService.showNotification(
          this.preferenceKeyMap[field].message,
          NotificationClassEnum.SUCCESS
        );
      });
    }
  }

  fetchAccEligibilityRecipients() {
    this.isLoadingAccRecipients = true;
    this.providerService.geAlltPractitioners()
      .pipe(
        finalize(() => {
          this.isLoadingAccRecipients = false;
        })
      )
      .subscribe(({
        next: (res) => {
          this.accEligibilityAllRecipients = [...res.response].sort((a, b) => {
            const nameA = `${a.firstName ?? ''} ${a.lastName ?? ''}`.trim();
            const nameB = `${b.firstName ?? ''} ${b.lastName ?? ''}`.trim();

            return nameA.localeCompare(nameB, undefined, {
              sensitivity: 'base'
            });
          });
        },
        error: () => {
          this.cvaNotificationService.showNotification(
            CVA_CONSTANTS.MESSAGE.RECIPIENTS_ERROR,
            NotificationClassEnum.ERROR
          );
        }
      }))
  }

}
